<nav>
  <ng-container *ngFor="let step of stepArray">
    <span class="step-circle" [ngClass]="{'active': (currentStep | async) === step}"></span>
  </ng-container>
</nav>
